// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"64ba3795","194":"131be432","232":"54acab62"}[chunkId] + ".chunk.js";
};